<script setup lang="ts">
const { t } = useI18n()
const socials = useSocials()

const resultSubPages = await fetchSubPages()
const { data: subPages } = toRefs(resultSubPages)
</script>

<template>
  <div class="mx-auto max-w-7xl px4 py6 lg:px8 lg:py12 sm:px6">
    <Footer
      :columns="4"
      :open="[t('general.company.label')]"
      class="mx-auto max-w-7xl px4 py6 md:border-t md:n-border-200 lg:px8 lg:py12 sm:px6"
    >
      <template #columns>
        <FooterColumn :title="t('form.company.label')" :default-open="true">
          <CompanyInfo />
        </FooterColumn>
        <template v-for="subPage in subPages" :key="subPage.id">
          <FooterColumn v-if="subPage.pages.some((sp) => sp.show)" :title="subPage.name">
            <template v-for="showInSubPage in subPage.pages">
              <li v-if="showInSubPage.show" :key="showInSubPage.id" :title="showInSubPage.page.name" class="!m-0.5">
                <NuxtLinkLocale :to="`/pages/${showInSubPage.page.slug}`" class="text-base">
                  {{ showInSubPage.page.name }}
                </NuxtLinkLocale>
              </li>
            </template>
          </FooterColumn>
        </template>
      </template>
    </Footer>
  </div>
  <div class="mx-auto max-w-7xl overflow-hidden border-t n-border-200 pb6 pt6">
    <div class="flex justify-between">
      <div>
        &copy; {{ new Date().getFullYear() }} {{ $config.public.company.name }}, {{ t('general.all_rights_reserved.label') }}
      </div>
      <div class="flex gap-x-1">
        <div v-for="social in socials" :key="social.label">
          <NLink :href="social.href" n="slate4 hover:slate5" target="_blank">
            <span class="sr-only" v-text="social.label" />
            <Icon :name="social.icon" class="text-xl" />
          </NLink>
        </div>
      </div>
    </div>
  </div>
</template>
